<fcom-modal
  class="itinerary-modal"
  [title]="'itinerary.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  (close)="closed.emit(true)"
  [(open)]="itineraryModal().open"
>
  @if (itineraryModal().data?.bound$ | async; as bound) {
    @let boundType = itineraryModal().data?.boundType$ | async;
    @let boundNumber = itineraryModal().data?.boundNumber$ | async;
    @let locations = itineraryModal().data?.locations$ | async;
    <fin-itinerary-timeline
      class="block pr-medium"
      [bound]="bound"
      [boundType]="boundType"
      [title]="'multiCity.flightSelection.flightNumber' | finLocalization: [boundNumber]"
      [locations]="locations"
    />
  }
</fcom-modal>
